import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AddToCart from 'components/brandActivation/addToCart';
import './style.css';

const ProductsListView = ({ data = [] }) => {
  return (
    <div className="product-wrapper">
      {data.length > 0 ? (
        <ul className="products-list">
          {data.map((item) => (
            <li key={item.id}>
              <Link
                to={`/dashboard/brand-activation/product-details/${item.id}`}
              >
                <figure>
                  <img src={item.images[0].image} alt={item.name} />
                </figure>
                <div className="title">{item.name}</div>
                <div className="description">{item.description}</div>
                <div className="prices">
                  <span>{`₹${item.selling_price}`}</span>
                  <span>
                    <del>{`₹${item.price}`}</del>
                  </span>
                </div>
              </Link>
              <AddToCart product={item} listing />
            </li>
          ))}
        </ul>
      ) : (
        <div>No Products</div>
      )}
    </div>
  );
};

ProductsListView.propTypes = {
  details: PropTypes.any,
};

export { ProductsListView };
export default ProductsListView;
